"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Region = exports.ApiEnv = void 0;
var ApiEnv;
(function (ApiEnv) {
    ApiEnv["LOCAL"] = "local";
    ApiEnv["QA"] = "qa";
    ApiEnv["STG"] = "stg";
    ApiEnv["PROD"] = "prod";
})(ApiEnv || (exports.ApiEnv = ApiEnv = {}));
var Region;
(function (Region) {
    Region["US"] = "us";
    Region["EMEA"] = "emea";
    Region["APAC"] = "apac";
    Region["AUS"] = "aus";
    Region["FEDRAMP"] = "fedramp";
})(Region || (exports.Region = Region = {}));
